import { useState } from 'react';

import {
    BottomSheet,
    BottomSheetFooter,
    Button as MagritteButton,
    ButtonMode,
    ButtonSize,
    Title,
    useBreakpoint,
} from '@hh.ru/magritte-ui';
import { ShareWebOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Notices, { MarkAsViewedEvent } from 'Modules/Notices';
import MagritteInfotip from 'src/components/Infotip/MagritteInfotip';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

import styles from './index.less';

const INFOTIP_NAME = 'share-resume-info';

const TrlKeys = {
    infoTip: 'employer.resume.button.share.infoTip',
    title: 'employer.resume.button.share',
    whatsNew: 'employer.resume.button.share.whatsNew',
    close: 'employer.resume.button.share.close',
};

interface ShareButtonProps {
    onClick: () => void;
    showInfotip: boolean;
}

const ShareButton: TranslatedComponent<ShareButtonProps> = ({ trls, onClick, showInfotip }) => {
    const { isMobile } = useBreakpoint();
    const [showTip, setShowTip] = useState(showInfotip);
    const isInfotipActive = useSelector((state) => state.infoTip.name === INFOTIP_NAME);

    const handleClickInfotip = () => {
        Notices.markAsViewed(INFOTIP_NAME);
        setShowTip(false);
    };

    const buttonProps = {
        mode: 'secondary' as ButtonMode,
        size: 'small' as ButtonSize,
        icon: <ShareWebOutlinedSize16 />,
        onClick,
        ariaLabel: trls[TrlKeys.title],
        dataQa: 'employer-share-resume',
        title: trls[TrlKeys.title],
    };

    if (isMobile) {
        return (
            <>
                <MagritteButton stretched {...buttonProps}>
                    {trls[TrlKeys.title]}
                </MagritteButton>
                <BottomSheet
                    visible={showTip && isInfotipActive}
                    onClose={handleClickInfotip}
                    footer={
                        <BottomSheetFooter>
                            <MagritteButton stretched onClick={handleClickInfotip} mode="primary" style="accent">
                                {trls[TrlKeys.close]}
                            </MagritteButton>
                        </BottomSheetFooter>
                    }
                >
                    <Title
                        Element="h4"
                        size="small"
                        alignment="center"
                        description={trls[TrlKeys.infoTip]}
                        descriptionStyle="tertiary"
                    >
                        {trls[TrlKeys.whatsNew]}
                    </Title>
                </BottomSheet>
            </>
        );
    }

    return (
        <MagritteInfotip
            placement="top-right"
            name={INFOTIP_NAME}
            visible={showTip}
            onClose={handleClickInfotip}
            markAsViewedEvent={MarkAsViewedEvent.OnHide}
            closeByClickOutside={false}
            showClose
            render={({ activatorRef }) => (
                <MagritteButton {...buttonProps} ref={activatorRef as React.Ref<HTMLButtonElement>}>
                    {null}
                </MagritteButton>
            )}
            useDefaultHost
        >
            <span className={styles.infotip}>{trls[TrlKeys.infoTip]}</span>
        </MagritteInfotip>
    );
};

export default translation(ShareButton);
